export default __webpack_public_path__ + "static/media/contact2.cd4da374.jpg";